
import { createContext, useContext, useState,useEffect } from "react";

const AuthContext = createContext();

export const useAuth = () => {
  return useContext(AuthContext);
};

export const AuthProvider = ({ children }) => {
  const [authenticated, setAuthenticated] = useState(localStorage.getItem("token")?true:false);
  const [isBlock, setIsBlock] = useState("0")
  const [userId, setUserId] = useState("")

 useEffect(() => {
  if(localStorage.getItem("token")){
    setAuthenticated(true);
  }
 }, [authenticated])

  const login = () => {
    // Implement your authentication logic here
    setAuthenticated(true);
  };

  const logout = () => {
    // Implement your logout logic here
    localStorage.clear()
    setAuthenticated(false);
  };

  return (
    <AuthContext.Provider value={{ authenticated, login, logout,isBlock, setIsBlock,userId, setUserId }}>
      {children}
    </AuthContext.Provider>
  );
};